import { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import { api } from "@/lib/api";

export default function ActivityPage() {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    api.get("/api/user/audit").then((r) => setLogs(r.data));
  }, []);
  return (
    <AppShell>
      <div className="space-y-6">
        <div>
          <h1 className="text-[26px] font-bold text-cm-navy tracking-tight">Activity</h1>
          <p className="mt-1 text-[13px] text-cm-grey">
            Login and security events on your account (retained per FIU-IND rules).
          </p>
        </div>
        <div className="bg-white rounded-[16px] border border-[var(--cm-border)] overflow-hidden">
          <table className="w-full text-[13px]">
            <thead className="bg-cm-surface text-cm-grey text-left">
              <tr>
                <th className="px-5 py-3 font-semibold">Event</th>
                <th className="px-5 py-3 font-semibold">Status</th>
                <th className="px-5 py-3 font-semibold">IP</th>
                <th className="px-5 py-3 font-semibold">Time</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[var(--cm-border)]">
              {logs.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-5 py-6 text-center text-cm-grey">
                    No activity yet.
                  </td>
                </tr>
              )}
              {logs.map((l, i) => (
                <tr key={i} data-testid={`activity-row-${i}`}>
                  <td className="px-5 py-3 text-cm-navy font-medium">{l.event}</td>
                  <td className="px-5 py-3">
                    <span
                      className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${
                        l.ok
                          ? "bg-emerald-50 text-emerald-700"
                          : "bg-red-50 text-red-700"
                      }`}
                    >
                      {l.ok ? "success" : "failed"}
                    </span>
                  </td>
                  <td className="px-5 py-3 text-cm-grey font-mono">{l.ip || "—"}</td>
                  <td className="px-5 py-3 text-cm-grey">
                    {l.created_at ? new Date(l.created_at).toLocaleString() : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AppShell>
  );
}
